const e = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M1.157 8.889A6.126 6.126 0 0 1 12 4.98a6.126 6.126 0 1 1 8.707 8.556l-8.027 7.435a1 1 0 0 1-1.359 0l-8.017-7.425a6.112 6.112 0 0 1-2.146-4.657Z"></path></svg>';
export {
  e as default
};
